import { formatLoggerData, logger } from 'services/logger';
import { queueMap } from './queueMap';
import { refreshScenario } from 'views/Multitab/channel';
import { captureDuration } from './qaPairTimestamp';
import {
  submitSupplementKnowledge,
  SubmitSupplementKnowledgeBody,
} from 'services/api/supplementKnowledge';
import { isNimCacheId } from './getNimCacheId';
import { useAfterSubmitClearKnowledgeQuery, useCleanQAPair } from './useCleanQAPair';
import { useUpdateQAPairRecord } from './useQAPairRecord';

export const useSupplementKnowledgeQueue = () => {
  const submitAfterClearKnowledgeQuery = useAfterSubmitClearKnowledgeQuery();
  const cleanQAPair = useCleanQAPair();
  const updateQAPairRecord = useUpdateQAPairRecord();

  const submit = async (body: SubmitSupplementKnowledgeBody) => {
    const { conversationId, supplementalKnowledgeValue } = body;
    const isAllSuccess = supplementalKnowledgeValue.originAnswers.every(
      (item) => item.messageId && !isNimCacheId(item.messageId),
    );
    /**
     * 如果提交知识的消息都已发送，则直接提交
     * 否则将请求暂存到队列中
     */
    if (isAllSuccess) {
      try {
        logger.info(
          `[useSupplementKnowledgeQueue][submit] ${formatLoggerData({
            body,
          })}`,
        );
        captureDuration(conversationId, '$submitSupplementKnowledgeDuration', true);
        cleanQAPair();
        const { supplementalKnowledgeValue } = body;
        await submitSupplementKnowledge(body);
        const queryMsgIds = supplementalKnowledgeValue.originQuestions
          .map((item) => item.messageId)
          .filter((item) => item) as string[];
        await submitAfterClearKnowledgeQuery(queryMsgIds);
        updateQAPairRecord(
          supplementalKnowledgeValue.originQuestions,
          supplementalKnowledgeValue.originAnswers,
        );
        refreshScenario('supplementKnowledge');
      } catch (err: any) {
        logger.error(
          `submit createSupplementKnowledge ${formatLoggerData({
            errMsg: err?.message || '',
            body,
          })}`,
        );
      } finally {
        queueMap.delete(conversationId);
      }
    } else {
      logger.info(
        `[useSupplementKnowledgeQueue]push to queue ${formatLoggerData({
          body,
        })}`,
      );
      queueMap.set(conversationId, body);
    }
  };

  return { submit };
};
